// Angle brackets are the only printable characters a city name never needs, and the
// only ones that let a value read as markup to whatever consumes it downstream.
// Stripping them on change keeps them out of the form state without adding a
// validation rule that could block an applicant.
const normalizeCity = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/[<>]/g, '');
};

export default normalizeCity;
